export const ActionTypes = {
  SET_TOP_UP_TEMPLATES: 'SET_TOP_UP_TEMPLATES'
};
